// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H-x4","name":"styles_name__3W6XF","phone":"styles_phone__1WqCD"};